import React from "react";
import { FormContext } from "src/context/NewPremiseFormContext";
import {
  FileUploadFormikField,
  FileUploadFormikFieldProps,
} from "src/components/Fields/FileUpload";

export const NewPremiseFormFileUploadFormikField: React.FC<
  Omit<FileUploadFormikFieldProps, "setDisplayingSnackbar">
> = (props) => {
  const { setDisplayingSnackbar } = React.useContext(FormContext);
  return (
    <FileUploadFormikField
      {...props}
      setDisplayingSnackbar={setDisplayingSnackbar}
    />
  );
};
